import apiAddress from "../_sig_api/_apiadress";
import createOptions from "../_helper/createOptions";
import {CharacterFieldUpdateField} from "../_payload/CharacterFieldUpdateField";

export const CharFieldsUpdate=(cid:string,fields: CharacterFieldUpdateField[])=> {
        fetch(apiAddress + "/chars/", createOptions('UPDATE', {cid:cid,fields:fields}))
            .then((res) => res.json())
            .then((data) => console.log('CharFieldsUpdate repsonse', data))
}